<template>
    <div>
        <template v-if="crud_vendor === true && crud_vendor !==null">
            <form id="employeeForm" @submit.prevent="addVendorData">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Vendor </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/vendors" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list active">
                            <span class="status-highlighter">1</span>
                            Vendor Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">2</span>
                            Basic Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Company Name </label>
                                    <input autocomplete="off" v-model="form.companyName" type="text" name="companyName" class="form-control" :class="{ 'is-invalid': form.errors.has('companyName') }">
                                    <has-error :form="form" field="companyName"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Vendor Name <em class="required">*</em> </label>
                                    <input autocomplete="off" v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Mobile Number <em class="required">*</em> </label>
                                    <input autocomplete="off" v-model="form.mobile" type="text" @keypress="isNumber($event)" maxlength="12" name="mobile" class="form-control" :class="{ 'is-invalid': form.errors.has('mobile') }" placeholder="92XXXXXXXXXX">
                                    <has-error :form="form" field="mobile"></has-error>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> CNIC </label>
                                    <input autocomplete="off" v-model="form.cnic" maxlength="13" @keypress="isNumber($event)" type="text" name="cnic" class="form-control" :class="{ 'is-invalid': form.errors.has('cnic') }">
                                    <has-error :form="form" field="cnic"></has-error>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Vendor Email  </label>
                                    <input autocomplete="off" v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Address  </label>
                                    <input autocomplete="off" v-model="form.address" type="text" name="address" class="form-control" :class="{ 'is-invalid': form.errors.has('address') }">
                                    <has-error :form="form" field="address"></has-error>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_vendor === null">
             <preLoader></preLoader>
        </template>
        <template v-else-if="crud_vendor === false">
              <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                    companyName : '',
                    mobile : '',
                    email : '',
                    cnic : '',
                    address : '',
                    vid : this.$route.params.id
                }),
                crud_vendor : null
            }
        },
        methods: {
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            addVendorData() {
                this.$Progress.start();
                this.form.post('/api/addVendorPersonalDetail')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Vendor detail added successfully');
                            this.$router.push('/addVendorBasicDetail/'+res.data.data.id);
                        }else if(res.data.status == 409){
                            this.$Progress.fail();
                            this.showAlertBox('error','Vendor mobile number already exist');
                        }else if(res.data.status == 400){
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.msg);
                        }else{
                            this.$Progress.fail();
                        }
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
        },
        mounted() {
             this.can('crud_vendor').then(result => {
                this.crud_vendor = result.crud_vendor;
            }).then(result => {
                if(this.$route.params.id != null){
                    axios.get("/api/editVendor/" + this.$route.params.id)
                    .then(res => {
                        if (res.status == 200) {
                            if(res.data.wizard_cycle == 0){
                                this.form.name = res.data.name;
                                this.form.mobile = res.data.mobile_no;
                                this.form.companyName = res.data.companyName;
                                this.form.cnic = res.data.cnic;
                                this.form.email = res.data.email;
                                this.form.address = res.data.current_address;
                            }else if(res.data.wizard_cycle == 1){
                                this.$router.push('/addVendorBasicDetail/'+this.$route.params.id);
                            }else if(res.data.wizard_cycle == 2){
                                this.$router.push('/addVendorTaxDetail/'+this.$route.params.id);
                            }else if(res.data.wizard_cycle == 3){
                                this.$router.push('/addVendorPaymentDetail/'+this.$route.params.id);
                            }
                        } else {
                            Vue.$Progress.fail();
                            this.showAlertBox('error','Error to load data');
                        }
                    })
                    .catch(err => {
                        Vue.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
                }
            });
        }
    }
</script>
